<div class="card">
  <div class="card-header d-flex justify-content-between">
    <h4>KlarPris indkøb</h4>
    <div class="clearPriceButtons d-flex gap-3 justify-content-between align-items-center">
      <button class="btn btn-secondary" *ngIf="!!case && !!case.offerList" data-toggle="modal" data-target="#clearPriceOrderModal" (click)="autoSetDeliveryToClearPriceBasketInfo(); clearPriceStep = 0;">{{ 'Offers.GoToBasket' | translate }}</button>
  </div>
  </div>
  <div class="card-body" *ngIf="orderHistoryGotten && !!orderHistory">
    <table class="table table-sm table-striped table-hover" aria-label="Order history">
      <thead>
        <th scope="col">{{ 'Standard.Supplier' | translate }}</th>
        <th scope="col">{{ 'Standard.Date' | translate }}</th>
        <th scope="col">{{ 'Standard.Buyer' | translate }}</th>
        <th scope="col" class="text-right">{{ 'Standard.Quantity' | translate }} {{ 'Standard.Products' | translate }}</th>
        <th scope="col" class="text-right">{{ 'Standard.TotalPrice' | translate }}</th>
      </thead>
      <tbody>
        <tr *ngFor="let x of orderHistory" data-toggle="modal" data-target="#showOrder" (click)="showOrder(x.id)">
          <td><img class="img-responsive" src="../../../assets/wholesalerIcons/wholesaler_{{ x.wholesalerId }}_icon.png" alt="wholesaler"></td>
          <td>{{ x.orderDate + 'Z' | date:'dd-MM HH:mm' }}</td>
          <td>{{ x.userName }}</td>
          <td class="text-right">{{ x.productCount }}</td>
          <td class="text-right">{{ calc.numsCurrency(x.totalAmount) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="card-body" *ngIf="orderHistoryGotten && !orderHistory">
    Vi fandt ingen faktura på sagen.
  </div>
  <div class="card-body" *ngIf="!orderHistoryGotten">
    {{ 'Standard.Loading' | translate }} ...
  </div>
</div>

<!-- Purchase Modal -->
<div id="clearPriceOrderModal" class="modal fade">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="pendingMessageModalLabel">{{ 'Offers.GoToBasket' | translate }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </button>
          </div>
          <div class="modal-body" *ngIf="clearPriceStep == 0">
            <div *ngIf="case.offerList.length > 0">
              <div class="rowItem justify-content-between align-items-center" *ngFor="let o of case.offerList" (click)="docToClearPrice(o.offerId)">
                <div>
                  <div class="d-flex gap-3 align-items-center"><span class="badge {{ statusByGuid(o.statusId).color }}">{{ statusByGuid(o.statusId).text | translate }}</span><span># {{ o.offerNumber }}</span></div>
                  <div class="font-weight-bold ellipsis">{{ o.title }}</div>
                  <div class="d-flex align-items-center gap-3">
                    <div class="d-flex gap-1"><span class="text-muted">{{ 'Standard.CostPriceShort' | translate }}:</span><span class="font-weight-bold"> {{ +o.costPrice | number: '1.2-2':'da' }}</span></div>
                    <div class="d-flex gap-1"><span class="text-muted">{{ 'Standard.SalesPriceShort' | translate }}:</span><span class="font-weight-bold"> {{ +o.totalPrice | number: '1.2-2':'da' }}</span></div>
                  </div>
                </div>
                <div style="width:2rem;">
                  <input class="form-control" type="radio" [checked]="clearPriceDocuments.includes(o.offerId)" />
                </div>
              </div>
            </div>
            <div *ngIf="!!unitData">
              <div class="rowItem justify-content-between align-items-center">
                <div style="width: calc(100% - 3rem);">
                  <div class="font-weight-bold">{{ 'Shop.Package' | translate }}</div>
                  <div class="ellipsis">{{ unitData.name }}</div>
                </div>
                <div style="width: 2rem;">
                  <input class="form-control" type="radio" [checked]="!!unitData" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body d-flex flex-column gap-3" *ngIf="clearPriceStep == 1">
              <div class="d-flex align-items-center gap-3">
                  <div class="flex-1">{{ 'Cases.CaseNumber' | translate }}</div>
                  <div class="flex-2"><input type="text" [(ngModel)]="clearPriceBasketInfo.orderNumber" class="form-control" autocomplete="off" placeholder="{{ 'Standard.Required' | translate }}"></div>
              </div>
              <div class="d-flex align-items-center gap-3">
                  <div class="flex-1">{{ 'Standard.Name' | translate }}</div>
                  <div class="flex-2">
                      <input type="text" [(ngModel)]="clearPriceBasketInfo.name" class="form-control" autocomplete="off" placeholder="{{ 'Standard.Required' | translate }}">
                  </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                  <div class="flex-1">{{ 'Standard.Address' | translate }}</div>
                  <div class="flex-2">
                      <input type="text" [(ngModel)]="clearPriceBasketInfo.address" class="form-control" autocomplete="off" />
                  </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                  <div class="flex-1">{{ 'Standard.Zipcode' | translate }}</div>
                  <div class="flex-2">
                      <input type="text" [(ngModel)]="clearPriceBasketInfo.zipCode" class="form-control" autocomplete="off" />
                  </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                  <div class="flex-1">{{ 'Standard.City' | translate }}</div>
                  <div class="flex-2">
                      <input type="text" [(ngModel)]="clearPriceBasketInfo.city" class="form-control" autocomplete="off" />
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" *ngIf="clearPriceStep == 0">{{ 'Buttons.Close' | translate }}</button>
              <button class="btn btn-secondary" (click)="clearPriceStep = 0" *ngIf="clearPriceStep == 1">{{ 'Buttons.Back' | translate }}</button>
              <button class="btn btn-primary" [disabled]="!unitData && !clearPriceDocuments.length" (click)="clearPriceStep = 1;" *ngIf="clearPriceStep == 0">{{ 'Buttons.Next' | translate }}</button>
              <button class="btn btn-primary" (click)="addToBasket()" [disabled]="clearPriceBasketInfo.orderNumber == '' || clearPriceBasketInfo.name == ''" data-dismiss="modal" *ngIf="clearPriceStep == 1">{{ 'Offers.GoToBasket' | translate }}</button>
          </div>
      </div>
  </div>
</div>

<!-- Show OrderHistory Modal -->
<div class="modal fade" id="showOrder" tabindex="-1" role="dialog" aria-labelledby="showOrderLabel" aria-hidden="true" *ngIf="!!selectedOrder && selectedOrder.id != null">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title" id="showOrderLabel">{{ 'Standard.OrderHistory' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <div class="row">
          <div class="col-6">
            <img class="img-responsive" src="../../../assets/wholesalerIcons/wholesaler_{{ selectedOrder.wholesalerId }}_icon.png" alt="wholesaler">
          </div>
          <div class="col-6 text-right">
            {{ 'Standard.Date' | translate }}: {{ selectedOrder.orderDate + 'Z' | date:'dd-MM HH:mm' }}
          </div>
          <div class="col-12 mt-3">
            <h5>{{ 'Standard.DeliveryAddress' | translate }}</h5>
            {{ selectedOrder.deliveryAddress }}
          </div>
          <div class="col-12 mt-3">
            <h5>{{ 'Standard.Buyer' | translate }}</h5>
            {{ selectedOrder.userName }}
          </div>
          <div class="col-12">
            <table class="table table-sm table-striped table-hover mt-3" aria-label="Order products">
              <thead>
                <th></th>
                <th>{{ 'Standard.ArticleNumber' | translate }}</th>
                <th class="ellipsis">{{ 'Standard.Name' | translate }}</th>
                <th>{{ 'Standard.Quantity' | translate }}</th>
                <th class="text-right">{{ 'OfferDetails.Pcs' | translate }} {{ 'Offers.Price' | translate }}</th>
                <th class="text-right">{{ 'Standard.TotalPrice' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let x of orderHistoryLines">
                  <td><img class="img-responsive wholesaler-images-table" src="https://klarprisassets.blob.core.windows.net/thumbnails/dk/{{ x.number }}_small.jpg" alt="wholesaler"></td>
                  <td>{{ x.number }}</td>
                  <td class="ellipsis">{{ x.description }}</td>
                  <td>{{ x.quantity }}</td>
                  <td class="text-right">{{ calc.numsCurrency(x.totalAmount / x.quantity) }}</td>
                  <td class="text-right">{{ calc.numsCurrency(x.totalAmount) }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">{{ 'Standard.TotalPrice' | translate }}:</td>
                  <td class="text-right">{{ calc.numsCurrency(selectedOrder.totalAmount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>